import ColorThemeOptions from "./colorTheme.options";
import { LightTheme, DarkTheme } from "./colorTheme.config";

const ColorThemeMap = {
  [ColorThemeOptions.LIGHT]: LightTheme,
  [ColorThemeOptions.DARK]: DarkTheme,
};

export default ColorThemeMap;
